import React from 'react';
import Icon from '../../../components/AppIcon';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SubscriptionMetricsCard = ({ title, currentValue, previousValue, chartData, icon, trend }) => {
  const percentageChange = previousValue ? (((currentValue - previousValue) / previousValue) * 100)?.toFixed(1) : 0;
  const isPositive = percentageChange >= 0;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-2 shadow-elevation-3">
          <p className="text-xs font-medium text-foreground">{payload?.[0]?.payload?.month}</p>
          <p className="text-xs text-primary">${payload?.[0]?.value?.toLocaleString()}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 border border-border">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-xs md:text-sm text-muted-foreground mb-1">{title}</h3>
            <p className="text-2xl md:text-3xl font-semibold text-foreground">${currentValue?.toLocaleString()}</p>
          </div>
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${isPositive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
          <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} />
          <span className="text-xs font-medium">{Math.abs(percentageChange)}%</span>
        </div>
      </div>
      <div className="w-full h-32 md:h-40" aria-label={`${title} Trend Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 10 }}
              hide
            />
            <YAxis hide />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="value"
              stroke="var(--color-primary)"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground">
          vs. previous period: <span className="font-medium text-foreground">${previousValue?.toLocaleString()}</span>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionMetricsCard;